export class OutletPeerV11 {
    static constructFromPlainObjectList(plainList) {
        const outletPeers = [];
        if (plainList && Array.isArray(plainList)) {
            for (const obj of plainList) {
                outletPeers.push(OutletPeerV11.constructFromPlainObject(obj));
            }
        }
        return outletPeers;
    }
    static constructFromPlainObject(plain) {
        let outletPeer = new OutletPeerV11();
        outletPeer = Object.assign(outletPeer, plain);
        return outletPeer;
    }
    constructor() {
        this.userId = '';
        this.loginName = '';
        this.firstName = '';
        this.lastName = '';
    }
    getId() {
        return this.userId;
    }
    getLoginName() {
        return this.loginName;
    }
    getFirstName() {
        return this.firstName;
    }
    getLastName() {
        return this.lastName;
    }
}
//# sourceMappingURL=outletPeerV11.js.map